import { cn } from 'utils/cn';

const TILE = 'bg-card border-border absolute rounded-[5px] border';
const TOP_ROW = 'top-2.5 h-[26px] w-[94px]';

/**
 * The arranging step's demo, under the card's body: a mini Home that is moved, resized and removed from, in a loop
 * that plays twice. The last widget of the top row is picked up and lands in the amber slot the one
 * before it opened; the wide widget below shrinks to one column; it then goes, the one beside it closing up each
 * time, and a new one arrives. The widget acted on shows it: lifted while its size changes, red before it goes,
 * amber as it arrives. Markup and keyframes only. Where the keyframes do not run, under reduced motion or not, it
 * is the still of the widget in the air over its slot: the utilities here draw that still, and each keyframe
 * replaces what it changes.
 */
export default function WidgetArrangeDemo() {
    return (
        <div
            aria-hidden
            className="bg-surface-subtle border-neutral-tint relative h-24 overflow-hidden rounded-lg border"
        >
            <span className={cn(TILE, TOP_ROW, 'left-2.5')} />
            <span
                className={cn(
                    'widget-demo-slot border-changed-border bg-changed absolute left-28 rounded-[5px] border-[1.5px] border-dashed',
                    TOP_ROW
                )}
            />
            {/* The lifted widget where it rests: before the lift it stands last, after the landing in the slot. */}
            <span className={cn('widget-demo-rest left-28 opacity-0', TILE, TOP_ROW)} />
            <span className={cn('widget-demo-tile left-[214px]', TILE, TOP_ROW)} />
            <span className={cn('widget-demo-wide', TILE, 'top-11 left-2.5 h-[42px] w-[196px]')} />
            <span className={cn('widget-demo-last', TILE, 'top-11 left-[214px] h-[42px] w-[94px]')} />
            <span
                className={cn(
                    'widget-demo-chip bg-card shadow-drag absolute top-0 left-0 flex translate-x-[150px] translate-y-6 rotate-3 flex-col gap-[3px] rounded-[5px] px-2 py-1.5 outline-hidden',
                    'h-[26px] w-[94px]'
                )}
            >
                <span className="bg-border-dashed h-[3px] w-[34px] rounded-sm" />
                <span className="bg-primary h-1.5 w-12 rounded-sm" />
            </span>
        </div>
    );
}
